"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f111 = void 0;
exports.f111 = {
    "oaa": [
        "Cyrl"
    ],
    "oac": [
        "Cyrl"
    ],
    "oar": [
        "Syrc"
    ],
    "oav": [
        "Geor"
    ],
    "obi": [
        "Zyyy"
    ],
    "obk": [
        "Latn"
    ],
    "obl": [
        "Latn"
    ],
    "obm": [
        "Phnx"
    ],
    "obo": [
        "Latn"
    ],
    "obr": [
        "Mymr"
    ],
    "obt": [
        "Latn"
    ],
    "obu": [
        "Latn"
    ],
    "oc": [
        "Latn"
    ],
    "oca": [
        "Latn"
    ],
    "och": [
        "Zyyy"
    ],
    "ocm": [
        "Zyyy"
    ],
    "oco": [
        "Latn"
    ],
    "ocu": [
        "Latn"
    ],
    "oda": [
        "Latn"
    ],
    "odk": [
        "Arab"
    ],
    "odt": [
        "Latn"
    ],
    "odu": [
        "Latn"
    ],
    "ofo": [
        "Zyyy"
    ],
    "ofs": [
        "Latn",
        "Runr"
    ],
    "ofu": [
        "Latn"
    ],
    "ogb": [
        "Latn"
    ],
    "ogc": [
        "Latn"
    ],
    "oge": [
        "Geok"
    ],
    "ogg": [
        "Latn"
    ],
    "ogo": [
        "Latn"
    ],
    "ogu": [
        "Latn"
    ],
    "oht": [
        "Xsux"
    ],
    "ohu": [
        "Hung",
        "Latn"
    ],
    "oia": [
        "Latn"
    ],
    "oin": [
        "Latn"
    ],
    "oj": [
        "Latn",
        "Cans"
    ],
    "ojb": [
        "Latn",
        "Cans"
    ],
    "ojc": [
        "Latn"
    ],
    "ojp": [
        "Zyyy"
    ],
    "ojs": [
        "Cans",
        "Latn"
    ],
    "ojv": [
        "Latn"
    ],
    "ojw": [
        "Latn",
        "Cans"
    ],
    "oka": [
        "Latn",
        "Dupl"
    ],
    "okb": [
        "Latn"
    ],
    "okc": [
        "Latn"
    ],
    "okd": [
        "Latn"
    ],
    "oke": [
        "Latn"
    ],
    "okg": [
        "Latn"
    ],
    "okh": [
        "Zyyy"
    ],
    "oki": [
        "Latn"
    ],
    "okj": [
        "Zyyy"
    ],
    "okk": [
        "Latn"
    ],
    "okl": [
        "Zxxx"
    ],
    "okm": [
        "Hang"
    ],
    "okn": [
        "Zyyy"
    ],
    "oko": [
        "Hani"
    ],
    "okr": [
        "Latn"
    ],
    "oks": [
        "Latn"
    ],
    "oku": [
        "Latn"
    ],
    "okv": [
        "Latn"
    ],
    "okx": [
        "Latn"
    ],
    "okz": [
        "Khmr"
    ],
    "ola": [
        "Tibt"
    ],
    "old": [
        "Latn"
    ],
    "ole": [
        "Tibt"
    ],
    "olk": [
        "Latn"
    ],
    "olm": [
        "Latn"
    ],
    "olo": [
        "Latn"
    ],
    "olr": [
        "Latn"
    ],
    "olt": [
        "Latn"
    ],
    "olu": [
        "Latn"
    ],
    "om": [
        "Latn",
        "Arab",
        "Ethi"
    ],
    "oma": [
        "Latn"
    ],
    "omb": [
        "Latn"
    ],
    "omc": [
        "Latn"
    ],
    "omg": [
        "Latn"
    ],
    "omi": [
        "Latn"
    ],
    "omk": [
        "Cyrl"
    ],
    "oml": [
        "Latn"
    ],
    "omn": [
        "Lina"
    ],
    "omo": [
        "Latn"
    ],
    "omp": [
        "Mtei"
    ],
    "omr": [
        "Modi"
    ],
    "omt": [
        "Latn"
    ],
    "omu": [
        "Latn"
    ],
    "omw": [
        "Latn"
    ],
    "omx": [
        "Mymr"
    ],
    "omy": [
        "Zyyy"
    ],
    "ona": [
        "Latn"
    ],
    "onb": [
        "Zyyy"
    ],
    "one": [
        "Latn"
    ],
    "ong": [
        "Latn"
    ],
    "oni": [
        "Latn"
    ],
    "onj": [
        "Latn"
    ],
    "onk": [
        "Latn"
    ],
    "onn": [
        "Latn"
    ],
    "ono": [
        "Latn"
    ],
    "onp": [
        "Deva",
        "Latn"
    ],
    "onr": [
        "Latn"
    ],
    "ons": [
        "Latn"
    ],
    "ont": [
        "Latn"
    ],
    "onu": [
        "Latn"
    ],
    "onw": [
        "Copt"
    ],
    "onx": [
        "Latn"
    ],
    "ood": [
        "Latn"
    ],
    "oog": [
        "Zyyy"
    ],
    "oon": [
        "Zyyy"
    ],
    "oor": [
        "Latn"
    ],
    "oos": [
        "Zyyy"
    ],
    "opa": [
        "Latn"
    ],
    "opk": [
        "Latn"
    ],
    "opm": [
        "Latn"
    ],
    "opo": [
        "Latn"
    ],
    "opt": [
        "Latn"
    ],
    "opy": [
        "Latn"
    ],
    "or": [
        "Orya",
        "Brai"
    ],
    "ora": [
        "Latn"
    ],
    "orc": [
        "Latn"
    ],
    "ore": [
        "Latn"
    ],
    "org": [
        "Latn"
    ],
    "orh": [
        "Zyyy"
    ],
    "orn": [
        "Latn"
    ],
    "oro": [
        "Latn"
    ],
    "orr": [
        "Latn"
    ],
    "ors": [
        "Latn"
    ],
    "ort": [
        "Telu"
    ],
    "oru": [
        "Arab"
    ],
    "orv": [
        "Cyrl"
    ],
    "orw": [
        "Latn"
    ],
    "orx": [
        "Latn"
    ],
    "orz": [
        "Latn"
    ],
    "os": [
        "Cyrl",
        "Geor",
        "Latn"
    ],
    "osa": [
        "Osge",
        "Latn"
    ],
    "osc": [
        "Ital",
        "Latn"
    ],
    "osi": [
        "Java"
    ],
    "osn": [
        "Sund"
    ],
    "oso": [
        "Latn"
    ],
    "osp": [
        "Latn"
    ],
    "ost": [
        "Latn"
    ],
    "osu": [
        "Latn"
    ],
    "osx": [
        "Latn"
    ],
    "ota": [
        "Arab"
    ],
    "otb": [
        "Tibt"
    ],
    "otd": [
        "Latn"
    ],
    "ote": [
        "Latn"
    ],
    "oti": [
        "Latn"
    ],
    "otk": [
        "Orkh"
    ],
    "otl": [
        "Latn"
    ],
    "otm": [
        "Latn"
    ],
    "otn": [
        "Latn"
    ],
    "otq": [
        "Latn"
    ],
    "otr": [
        "Latn"
    ],
    "ots": [
        "Latn"
    ],
    "ott": [
        "Latn"
    ],
    "otu": [
        "Latn"
    ],
    "otw": [
        "Latn"
    ],
    "otx": [
        "Latn"
    ],
    "oty": [
        "Gran"
    ],
    "otz": [
        "Latn"
    ],
    "oua": [
        "Zyyy"
    ],
    "oub": [
        "Latn"
    ],
    "oue": [
        "Latn"
    ],
    "oui": [
        "Ougr",
        "Mong"
    ],
    "oum": [
        "Latn"
    ],
    "ovd": [
        "Latn"
    ],
    "owi": [
        "Latn"
    ],
    "owl": [
        "Latn"
    ],
    "oyb": [
        "Zyyy"
    ],
    "oyd": [
        "Latn"
    ],
    "oym": [
        "Latn"
    ],
    "oyy": [
        "Latn"
    ],
    "ozm": [
        "Latn"
    ]
};
